import { css } from '@emotion/react';

import { breakpoints, colors } from '@/styles';
import { fontSizes, p2r, SecondaryProps } from '@/styles/fonts';

const styles = css`
  display: none;
  align-items: baseline;

  & > span {
    ${fontSizes.text}
    ${SecondaryProps}
  }

  @media (max-width: ${breakpoints.tablet}px) {
    display: flex;
  }

  .btn {
    position: relative;
    z-index: 999;
    width: 22px;
    height: 15px;
    margin-right: 5px;
    background: inherit;
    transition: all 0.3s ease 0s;

    @media (max-width: ${breakpoints.tablet}px) {
      &.active {
        position: absolute;
        top: 0;
        right: 0;
        box-sizing: border-box;
        padding: ${p2r(24)} 24px;
        margin-right: unset;
        background: ${colors.lightBlue};
      }
    }

    span {
      position: absolute;
      top: 6px;
      left: 0;
      width: 100%;
      height: 3px;
      background-color: ${colors.black};
    }

    &.active {
      span {
        display: none;
      }
    }

    &::after,
    &::before {
      position: absolute;
      left: 0;
      width: 100%;
      max-width: 24px;
      height: 3px;
      content: '';
      background-color: ${colors.black};
      transition: all 0.3s ease 0s;
    }

    &:after {
      bottom: 0;
    }

    &:before {
      top: 0;
    }

    &.active:before,
    &.active:after {
      left: 50%;
    }

    &.active:before {
      top: 4px;
      transform: translateX(-50%) rotate(45deg);

      @media (max-width: ${breakpoints.tablet}px) {
        top: 22px;
        background: ${colors.white};
      }
    }

    &.active:after {
      bottom: 8px;
      transform: translateX(-50%) rotate(-45deg);

      @media (max-width: ${breakpoints.tablet}px) {
        bottom: 23px;
        background: ${colors.white};
      }
    }
  }
`;

export default styles;
